import React, { ReactNode } from 'react';
import { CircularProgress, Box } from '@mui/material';

interface LoaderProps {
  loading: boolean;
  children?: ReactNode;
  overlay?: boolean;
  color?: string;
  center?: boolean;
  size?: 'small' | 'medium' | 'large';
  style?: React.CSSProperties;
  [key: string]: any; // Allow additional props
}

const Loader = ({ loading, children, overlay, color, center, size, style }: LoaderProps): React.JSX.Element | null => {
  if (!loading) {
    return children as React.JSX.Element || null;
  }

  return (
    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', ...style }}>
      {overlay ? children : null}
      <Box
        id={overlay ? 'overlay' : undefined}
        className={
          overlay || center
            ? 'd-flex align-items-center justify-content-center'
            : undefined
        }
        sx={
          overlay
            ? {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
              }
            : {}
        }
      >
        <CircularProgress
          size={overlay ? 64 : (size === 'small' ? 15 : size === 'medium' ? 25 : 40)}
          sx={{
            color: color || (overlay ? 'white' : '#4154f1'),
          }}
        />
      </Box>
    </Box>
  );
};

export default Loader;

